import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setSelectedNexusFilterDate } from "../../store/nexusFilters";
import DatePicker from "./DatePicker";
import { useSearchParams } from "react-router-dom";
import {
  clearGanttChartData,
  clearPondooStatusData,
  resetGanttChartErrorMessage,
} from "../../store/ganttChart";
import dateUtil from "../../utils/dateUtil";
import { clearKpiData } from "../../store/KPICollection";

const HeaderCalendar = ({}: {}) => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const URLDate = searchParams.get("date");
  const sanitizeDateString = (date: string): string =>
    date.includes("T") ? date.split("T")[0] : date;
  const defaultDate = URLDate ? sanitizeDateString(URLDate) : undefined;
  const { calendarEndDate, calendarStartDate } = useAppSelector(
    (state) => state.nexusFiltersSlice,
  );

  const handleChange = (filterName: string, value?: string) => {
    dispatch(resetGanttChartErrorMessage());
    setSearchParams((prevParams) => {
      if (value) {
        prevParams.set(filterName, value);
      } else {
        prevParams.delete(filterName);
      }
      return prevParams;
    });
  };

  return (
    <div style={{ width: "225px" }}>
      <DatePicker
        showArrows
        min={calendarStartDate}
        max={calendarEndDate}
        setSelectedDate={(date: string) => {
          dispatch(setSelectedNexusFilterDate(sanitizeDateString(date)));
          handleChange("date", dateUtil.getCalendarValueString(new Date(date)));
        }}
        bgColor="white"
        color="var(--col-interaction-secondary)"
        defaultDate={URLDate ? URLDate : undefined}
        cleanUpFn={() => {
          // We must clear the Gantt chart data when navigating
          dispatch(clearGanttChartData());
          dispatch(clearKpiData());
          dispatch(clearPondooStatusData());
        }}
      />
    </div>
  );
};

export default HeaderCalendar;
